import CustomModal from "../CustomModal";
import { useLocations } from "../../../hooks/useLocations";

const EditStaffModal = ({
  isOpen,
  onRequestClose,
  selectedAdmin,
  formData,
  handleChange,
  handleEditSubmit,
}) => {
  // Use custom hook for locations
  const { locations, loading: loadingLocations, currentAdminRoleId } = useLocations(isOpen);
  
  // Only show Super Admin option if current admin is Super Admin (role_id = 3)
  const canCreateSuperAdmin = currentAdminRoleId === 3;

  // Handler for location select
  const handleLocationChange = (e) => {
    const locationId = parseInt(e.target.value, 10);
    handleChange({ target: { name: "location_id", value: locationId } });
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Edit Admin Modal"
      className="add-admin-modal"
    >
      {selectedAdmin && (
        <div>
          <div className="add-staff-head">
            <h2>Edit staff details</h2>
          </div>
          <form onSubmit={handleEditSubmit} className="staff-form">
            <div className="inner-form">
              <label htmlFor="f_name">First Name:</label>
              <br />
              <input
                type="text"
                id="f_name"
                name="f_name"
                value={formData.f_name}
                onChange={handleChange}
              />
              <label htmlFor="l_name">Last Name:</label>
              <br />
              <input
                type="text"
                id="l_name"
                name="l_name"
                value={formData.l_name}
                onChange={handleChange}
              />
              <label htmlFor="address">Address:</label>
              <br />
              <input
                type="text"
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
              />
              <label htmlFor="email">Email:</label>
              <br />
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
              <label htmlFor="phone">Phone Number:</label>
              <br />
              <input
                type="tel"
                id="phone"
                name="phone"
                pattern="[0-9]{11}"
                value={formData.phone}
                onChange={handleChange}
              />
              <label htmlFor="nin">National Identification Number:</label>
              <br />
              <input
                type="text"
                id="nin"
                name="nin"
                value={formData.nin}
                onChange={handleChange}
              />

              <label htmlFor="location_id">Location:</label>
              <br />
              <select
                id="location_id"
                name="location_id"
                value={formData.location_id || ''}
                onChange={handleLocationChange}
                disabled={loadingLocations}
              >
                <option value="" disabled>
                  {loadingLocations ? 'Loading locations...' : 'Select a location'}
                </option>
                {locations.map(loc => (
                  <option key={loc.id} value={loc.id}>{loc.name}</option>
                ))}
              </select>

              <label htmlFor="role_id">Role:</label>
              <br />
              <select
                id="role_id"
                name="role_id"
                value={formData.role_id}
                onChange={handleChange}
              >
                <option value="2">Admin</option>
                {canCreateSuperAdmin && (
                  <option value="4">Branch Admin</option>
                )}
                {canCreateSuperAdmin && (
                  <option value="3">Super Admin</option>
                )}
              </select>
            </div>
            <div className="modal-button">
              <button type="button" onClick={onRequestClose}>
                Cancel
              </button>
              <input type="submit" value="Save Update" />
            </div>
          </form>
        </div>
      )}
    </CustomModal>
  );
};

export default EditStaffModal;
